export default __webpack_public_path__ + "static/media/Logo.40dca6a8.png";